<template>
  <div
    :class="['flex gap-y-3 gap-x-6', {
      'flex-col': position === 'vertical',
      'opacity-50 pointer-events-none': disabled
    }]">
    <div
      v-for="option in options"
      :key="option.value">
      <input
        :id="`${id}_${option.value}`"
        type="radio"
        :name="name"
        :value="option.value"
        :checked="modelValue === option.value"
        class="text-primary-500 bg-gray-100 border-gray-300 focus:ring-primary-500 dark:focus:ring-primary-600
          dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
        :disabled="disabled"
        :class="SIZES.RADIO[size]"
        @input="$emit('update:modelValue', option.value)">
      <slot name="label" :option="option">
        <label
          :class="['ms-2 text-gray-900 dark:text-gray-300 align-middle', SIZES.LABEL[size]]"
          :for="`${id}_${option.value}`">{{ option.label }}</label>
      </slot>
      <i v-if="option.tooltipText" v-tooltip="option.tooltipText" class="fa-solid fa-circle-info ml-1 text-gray-500 align-middle" />
    </div>
  </div>
</template>

<script setup>
import vTooltip from '~/javascript/directives/tooltip'

const SIZES = {
  LABEL: {
    default: 'text-base',
    lg: 'text-lg',
    sm: 'text-sm'
  },
  RADIO: {
    default: 'w-4.5 h-4.5',
    lg: 'w-5 h-5',
    sm: 'w-4 h-4'
  }
}

defineProps({
  id: { type: String, required: true },
  name: { type: String, default: '' },
  modelValue: { type: String, required: true },
  options: { required: true, type: Array },
  size: { type: String, default: 'default' },
  disabled: { type: Boolean, required: false, default: false },
  position: {
    type: String,
    default: 'vertical',
    validator(val) {
      return ['vertical', 'horizontal'].includes(val)
    }
  }
})

defineEmits(['update:modelValue'])
</script>
